export default __webpack_public_path__ + "static/media/ta.b75ea9fc.png";